import React, { SVGProps } from "react";

export const QuantityWidgetIcon4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={101}
    height={64}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#fff"
      stroke={props.stroke || "#BBB"}
      d="M.699.5H100.5v61.794H.699z"
    />
    <path
      fill={props.color || "#F1F1F1"}
      stroke={props.stroke || "#BBB"}
      d="M.699 46.77H100.5v16H.699z"
    />
  </svg>
);
